import React, {useState} from 'react';
import {Button, Input} from "@mui/material";
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import styles from "./Thought.module.scss";
import {thoughts} from "../assets/constants";
import PrevAndNextComponent from "../components/PrevAndNextComponent";
import HeaderWithSubHeader from "../components/HeaderWithSubHeader";
import TextQuestionWithIcon from "../components/TextQuestionWithIcon";

const commonThoughts = ['No one cares about me', 'I\'m a failure', 'I\'ll never be able to do anything', 'I am scared something bad will happen to the people I love', 'I will go crazy if I don\'t control my racing thoughts', ...thoughts];

const Thought = ({step, steps, handleNext, handleBack, activeStep, handleSetStepSummary}) => {
    const [inputValue, setInputValue] = useState(steps[activeStep].summary);

    // Event handler to update the input value
    const handleChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleButtonClick = (value) => {
        handleSetStepSummary({...step, summary: value});
        handleNext();
    };

    const handleLocalNext = () => {
        handleSetStepSummary({...step, summary: inputValue});
        handleNext();
    };

    return (
        <div style={{display: "flex", justifyContent: "flex-start", flexDirection: "column", textAlign: "left", fontSize: "24px"}}>
            <HeaderWithSubHeader steps={steps} step={step}/>
            <br/>
            <br/>
            <TextQuestionWithIcon text="What negative thought are you struggling with right now?" icon={<ArrowCircleRightOutlinedIcon />} />
            <br/>
            <Input placeholder="Enter your thought here" value={inputValue} onChange={handleChange}></Input>
            <br/>
            <PrevAndNextComponent steps={steps} activeStep={activeStep} handleBack={handleBack} handleLocalNext={handleLocalNext} />
            <br/>
            <p>
                Or, choose one of these common thoughts to work on:
            </p>
            <div style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                flexWrap: "wrap"
            }}>
                {commonThoughts.map((thought, index) => {
                    return (
                        <div key={index} className={styles.groupContainer} style={{marginBottom: "20px"}}>
                        <Button
                            key={index}
                            color="error"
                            size="medium"
                            variant="outlined"
                            onClick={() => handleButtonClick(thought)}
                            style={{color: "black", fontWeight: "400", fontFamily: "Verdana"}}
                        >
                            {thought}
                        </Button>
                    </div>);
                })}
            </div>
        </div>
    );
};

export default Thought;